import { useCallback, useState } from 'react';

export const useFolderModalState = () => {
  const [isOpenFolderRenameModal, setIsOpenFolderRenameModal] = useState(false);
  const [isOpenFolderDeleteModal, setIsOpenFolderDeleteModal] = useState(false);
  const [folderIdSelected, setFolderIdSelected] = useState<string | null>(null);
  const [folderNameSelected, setFolderNameSelected] = useState<string | null>(null);

  const onCloseFolderRenameModal = useCallback(() => setIsOpenFolderRenameModal(false), []);
  const onCloseFolderDeleteModal = useCallback(() => setIsOpenFolderDeleteModal(false), []);

  return {
    isOpenFolderRenameModal,
    isOpenFolderDeleteModal,
    folderIdSelected,
    folderNameSelected,
    setFolderIdSelected,
    setFolderNameSelected,
    setIsOpenFolderRenameModal,
    setIsOpenFolderDeleteModal,
    onCloseFolderRenameModal,
    onCloseFolderDeleteModal,
  };
};
